import { LocalStorageService } from './../../_services/local-storage.service';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl, AbstractControl, FormBuilder } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginService } from 'src/app/_services/login.service';
import { PersonSearchService } from 'src/app/_services/person-search.service';
import { TransactionService } from 'src/app/_services/transaction.service';

@Component({
    selector: 'app-edit-profile',
    templateUrl: './edit-profile.component.html',
    styleUrls: ['./edit-profile.component.scss'],
    standalone: false
})
export class EditProfileComponent implements OnInit {

  backupProfileobj:any;
  profile_form: UntypedFormGroup;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  continentsList: any;

  constructor(public modalService: NgbModal, private fb: FormBuilder, private transactionService: TransactionService,
    private _localstorageservice  :LocalStorageService,private _loginservice:LoginService, private personsearchService: PersonSearchService) { }

  ngOnInit() {
    this.getPreferredContinents();
    this.profile_form = this.fb.group({
      fname: [this.backupProfileobj ? this.backupProfileobj.firstname : '',Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z ]*$'),noWhitespaceValidator])],
      lname: [this.backupProfileobj ? this.backupProfileobj.lastname : '', Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z ]*$'),noWhitespaceValidator])],
      emailid: [this.backupProfileobj ? { value: this.backupProfileobj.loginemail , disabled: true } : '', Validators.required],
      mobileno: [this.backupProfileobj ? this.backupProfileobj.extn : '', Validators.compose([Validators.required,Validators.pattern('^[+]?[0-9 ]*$'),Validators.minLength(10),Validators.maxLength(15)])],
      designation: [this.backupProfileobj ? this.backupProfileobj.designation : '', Validators.compose([Validators.required,Validators.pattern(/^[a-zA-Z0-9\-'\.,@&\/\+\:\#_\(\)\"\'\* ]*$/)])],
      cname: [this.backupProfileobj ? this.backupProfileobj.company : '', Validators.compose([Validators.required,Validators.pattern(/^[a-zA-Z0-9\-'\.,@&\/\+\:\#_\(\)\"\'\* ]*$/)])],
      region: [this.backupProfileobj ? this.backupProfileobj.preferredsearchcontinent : '']
    })

    function noWhitespaceValidator(control: AbstractControl) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'required': true };
  }

  function ValidateHTMLTAGS(control: AbstractControl){
    if(control.value){
      const res = control.value.replace(/ /g, '')
      let scriptRegex = /^[a-zA-Z0-9\-'\.,@&\/\+\:\#_\(\)\"\'\* ]*$/;
      if(res && (scriptRegex.test(res.trim()) == true)){
        return { 'pattern': true }
      }else{
        return null
      }
    }
  }

  }

  saveDetails() {
    if (this.profile_form.valid) {
      let data ={
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "firstname": this.profile_form.value.fname,
        "lastname": this.profile_form.value.lname,
        "company": this.profile_form.value.cname,
        "designation": this.profile_form.value.designation,
        "extn": this.profile_form.value.mobileno,
        preferredsearchcontinent : this.profile_form.value.region
      }

      let activity =[]
      let backupProfileobj = {
        "firstname": this.backupProfileobj.firstname,
        "lastname": this.backupProfileobj.lastname,
        "company": this.backupProfileobj.company,
        "designation": this.backupProfileobj.designation,
        "extn": this.backupProfileobj.extn
      }

      let result = Object.keys(backupProfileobj).filter(k => backupProfileobj[k] !== data[k]);
        result.map((elem, index) => {
          activity.push({
            updatedfieldname: "'" + elem + "'",
            oldvalue: "'" + backupProfileobj[elem] + "'",
            newvalue: "'" + data[elem] + "'"
          })
        })

        // if(activity.length > 0){
        //   data['activitylog']=activity
        // }

          this._loginservice.updateuserDetails(data).subscribe((res:any)=>{
            if (res.status == "success") {
              this._localstorageservice.setItem('ufname', this.profile_form.value.fname)
              this._localstorageservice.setItem('ulname', this.profile_form.value.lname)
              this.transactionService.updateAccessDetailsForCurrentUser(true).subscribe();
              this.modalService.dismissAll();
              this.passEntry.emit('success')
            }
            else {
              this.modalService.dismissAll();
              this.passEntry.emit('error')

            }
          })




    } else {
      this.validateAllFormFields(this.profile_form);

    }
  }


  validateAllFormFields(formGroup: UntypedFormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof UntypedFormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof UntypedFormGroup) {
        this.validateAllFormFields(control);
      }
    });

  }

    getPreferredContinents() {
    this.personsearchService.getPreferredContinents().subscribe((res:any)=>{
      this.continentsList = res.data;
    })
  }
}
